module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226077086_06_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226077086_07_int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226077086_08_ch1#ch1"
    }
  }, [_vm._v("1. The Social Construction of Sovereign Responsibilities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226077086_09_ch2#ch2"
    }
  }, [_vm._v("2. Sovereignty in Early Modern Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_10_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Rise of Popular Sovereignty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_11_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sovereignty and the Non-European World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_12_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Sovereignty after the Second World War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_13_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Rise of the Responsibility to Protect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_14_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_15_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_16_ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226077086_17_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-012434e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226077086_05_toc.vue
// module id = 66
// module chunks = 0